import React from "react";

/**
 * Subtle gate/portal mark from v0 design (replaces leaf).
 */
export default function LeafgateLogo({ size = 32, color = "#191A1F", className = "" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M16 3C9.373 3 4 8.373 4 15c0 5.018 3.08 9.317 7.45 11.116C12.346 27.316 14.063 28 16 28c1.937 0 3.654-.684 4.55-1.884C24.92 24.317 28 20.018 28 15c0-6.627-5.373-12-12-12z"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M16 8a7 7 0 0 0-7 7c0 2.761 1.615 5.14 3.95 6.25.7.332 1.93.75 3.05.75s2.35-.418 3.05-.75A7.002 7.002 0 0 0 23 15a7 7 0 0 0-7-7z"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      <circle cx="16" cy="15" r="2.5" fill={color} />
    </svg>
  );
}
